import ChatwootService from '../services/ChatwootService';
import { handleDeepLinkNotificationPress } from './deepLinks/deepLinkRouter';
import { handleGettingStartedNotificationPress } from './gettingStartedPushNav';

/**
 * Where a tapped notification takes the user, whoever displayed it (notifee
 * in the foreground, the system in the background): a chat notice opens the
 * chat, a linked or typed push its deep link, a getting-started nudge its
 * task. False when the data names none of these.
 */
export const routeNotificationPress = async (
  data: unknown,
): Promise<boolean> => {
  if (!data || typeof data !== 'object') return false;
  if (await ChatwootService.openChatFromPush(data)) return true;
  if (await handleDeepLinkNotificationPress(data)) return true;
  return handleGettingStartedNotificationPress(data);
};
